"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeNameToOldTypeName = typeNameToOldTypeName;
function typeNameToOldTypeName(obj) {
    if (Array.isArray(obj)) {
        return obj.map(function (item) { return typeNameToOldTypeName(item); });
    }
    if (obj !== null && typeof obj === 'object') {
        var result = {};
        for (var key in obj) {
            var value = obj[key];
            if (key === '__typename' && typeof value === 'string') {
                result[key] = value.replace(/^_/, '');
            }
            else {
                result[key] = typeNameToOldTypeName(value);
            }
        }
        return result;
    }
    return obj;
}
//# sourceMappingURL=gql.js.map